export default class RemoveCustomerAssignee {
  constructor(context) {
    this.context = context;
  }

  run() {
    let currentCustomerId = this.context.stores.currentLocation.get().customerId;
    this.context.gateways.customerAssignee.remove(currentCustomerId);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer/remove_customer_assignee.js